import { UserProcess } from '@interfaces';

import { MyWorkPermit } from '../work-permits/work-permits.interfaces';

// Value of a work-permit option in the foreigner's application selector.
export interface WorkPermitApplication {
  id: string;
  isWorkPermit: true;
}

export const isWorkPermitApplication = (app: { id: string }): app is WorkPermitApplication =>
  (app as WorkPermitApplication)?.isWorkPermit === true;

// The most recently updated item across user-processes and work-permits; requires at least one item.
export const mostRecentForeignerApplication = (
  myProcesses: UserProcess[],
  myWorkPermits: MyWorkPermit[]
): UserProcess | WorkPermitApplication => {
  const items: { app: UserProcess | WorkPermitApplication; updatedAt: Date | string }[] = [
    ...myProcesses.map(userProcess => ({ app: userProcess, updatedAt: userProcess.updatedAt })),
    ...myWorkPermits.map(workPermit => ({
      app: { id: workPermit.id, isWorkPermit: true } as WorkPermitApplication,
      updatedAt: workPermit.updatedAt,
    })),
  ];
  return items.reduce((recent, item) => (new Date(item.updatedAt) > new Date(recent.updatedAt) ? item : recent)).app;
};

export const foreignerApplicationLinkParams = (app: UserProcess | WorkPermitApplication): string[] =>
  isWorkPermitApplication(app) ? ['/my-work-permit', app.id] : ['/user-process', app.id];
